import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/auth';
import icon from '../assets/icon.png';

const Login = ({ login, isAuthenticated }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const [showModal, setShowModal] = useState(false); // Tracks modal visibility
    const [errorMessage, setErrorMessage] = useState(''); // Stores error messages

    const { email, password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        try {
            await login(email, password);
        } catch (error) {
            setErrorMessage(error.message); // Set the error message from the thrown error
            setShowModal(true); // Show the modal
        }
    };

    if (isAuthenticated) {
        return <Navigate to="/systems" />;
    }

    return (
        <div className="container mt-5">
            <img src={icon} alt="Icon" style={{ width: '100px', height: 'auto', marginBottom: '15px' }} />
            <h1>Sign In</h1>
            <p>Sign into your InteliRain™ Account</p>

            <form onSubmit={e => onSubmit(e)}>
                <div className="form-group mb-3">
                    <input
                        className="form-control"
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={email}
                        onChange={e => onChange(e)}
                        required
                    />
                </div>

                <div className="form-group mb-3">
                    <input
                        className="form-control"
                        type="password"
                        placeholder="Password"
                        name="password"
                        value={password}
                        onChange={e => onChange(e)}
                        minLength="6"
                        required
                    />
                </div>

                <button className="btn btn-primary" type="submit">
                    Login
                </button>
            </form>

            <br />

            <p className="mt-3">
                Don't have an account? <Link to="/signup">Sign Up</Link>
            </p>

            <p className="mt-3">
                Forgot your password? <Link to="/reset-password">Reset Password</Link>
            </p>

            {/* Modal */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Login Failed</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>{errorMessage}</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login })(Login);
